import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
const STATUS_CONFIG = {
    active: { color: 'success', translationKey: 'common.active' },
    revoked: { color: 'error', translationKey: 'common.revoked' },
    expired: { color: 'warning', translationKey: 'common.expired' },
    disabled: { color: 'error', translationKey: 'common.disabled' },
};
const DEFAULT_CONFIG = {
    color: 'success',
    translationKey: 'common.active',
};
const StatusChip = ({ status, className, ...props }) => {
    const { t } = useTranslation();
    const normalizedStatus = status?.toLowerCase();
    const config = normalizedStatus && STATUS_CONFIG[normalizedStatus]
        ? STATUS_CONFIG[normalizedStatus]
        : DEFAULT_CONFIG;
    return (_jsx(Chip, { "data-label": "chip", className: `uppercase ${className || ''}`, color: config.color, label: t(config.translationKey), size: "small", ...props }));
};
export default StatusChip;
